module.exports = __webpack_public_path__ + "img/6_ralph_s.3a7f7052.png";